import { useMemo } from 'react';
import { usePermission } from './usePermission';
import { INVENTORY_PERMISSIONS } from '../constants/permissions.constants';

export const useInventoryRequestPermissions = () => {
  const canView = usePermission(INVENTORY_PERMISSIONS.REQUEST.VIEW);
  const canApprove = usePermission(INVENTORY_PERMISSIONS.REQUEST.APPROVE);

  return useMemo(
    () => ({
      canView,
      canApprove,
    }),
    [canView, canApprove],
  );
};

export const useInventoryGeneralRequestPermissions = () => {
  const canCreateRequest = usePermission(INVENTORY_PERMISSIONS.GENERAL.CREATE);

  return useMemo(
    () => ({
      canCreateRequest,
    }),
    [canCreateRequest],
  );
};
